import axios from 'axios';
import jwtDecode from 'jwt-decode';
import * as globals from '../constants/globals';
import * as errors from '../constants/errors';
import { forceLogOut, loginMessagesStorageKey, navigateLogin } from '../actions/login';

export const JSONContentType = 'application/json; charset=utf-8';

export const makeAuthorizedRequest = async (url, methodParam, dispatch, data, responseType) => {
  // eslint-disable-next-line no-undef
  const tokenString = localStorage.getItem(globals.TOKEN_LOCAL_STORAGE_KEY);
  if (!tokenString) {
    navigateLogin(window.location.pathname);
    throw new Error('No token stored in local storage');
  }

  const tokenObject = JSON.parse(tokenString);
  if (!tokenObject.access_token || jwtDecode(tokenObject.access_token).exp < Date.now() / 1000) {
    // eslint-disable-next-line no-undef
    localStorage.removeItem(globals.TOKEN_LOCAL_STORAGE_KEY);
    navigateLogin(window.location.pathname);
    throw new Error('Token has expired');
  }

  const headers = {
    Authorization: `Bearer ${tokenObject.access_token}`,
  };
  const method = methodParam.toUpperCase();
  if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
    headers['content-type'] = JSONContentType;
  }
  let throwError;
  const response = await axios({
    url,
    method,
    headers,
    data,
    responseType,
    credentials: 'include',
  }).catch((error) => {
    const errorResponse = error.response;

    if (errorResponse && errorResponse.data.error) {
      if (errorResponse.data.error.indexOf(errors.CONCURRENT_SESSION_ERROR) !== -1) {
        const loginMessages = JSON.stringify({ concurrentSessionError: true });
        localStorage.setItem(loginMessagesStorageKey, loginMessages);

        dispatch(forceLogOut(errors.CONCURRENT_SESSION_ERROR));
      } else if (errorResponse.data.error.indexOf(errors.EMAIL_NOT_CONFIRMED) !== -1) {
        dispatch(forceLogOut(errors.EMAIL_NOT_CONFIRMED));
      } else if (errorResponse.status === 401) {
        dispatch(forceLogOut(errors.NOT_AUTHORIZED));
      } else if (
        errorResponse.data.time_to_live &&
        errorResponse.data.error.indexOf(errors.RESEND_CONFIRMATION_ALREADY_SENT) !== -1
      ) {
        // For resend confirmation email
        throwError = errorResponse.data;
      } else {
        throwError = new Error(errorResponse.data.error);
      }
    } else {
      throwError = error;
    }
  });

  if (throwError) {
    throw throwError;
  } else {
    return response.data;
  }
};
